import React from 'react';
import { Form, Input, Button,Spin,Select,Switch,Divider } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';
import moment from 'moment';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''
var username=''
const dateFormat = 'DD/MM/YYYY';
const { TextArea } = Input;

const { Option } = Select;

class ActionWorkFlowMappingUpdateForm extends React.Component {

  state = {
    name:'' ,  
    datarequested:true,
    workflow_type:'',
    active:false,
    description:'',
    abbreviation:'',

    actions:[],
    action:'',

    staff_roles:[],
    responsible_roles:[],

    positive_application_status:'',
    negative_application_status:'',

    granting_stage:false,
    application_status_forgranting_licence:''

  }

  componentDidMount(){   
    this.component_reloaded()
  }


  component_reloaded=()=>{
   // this.setState({responsible_roles:JSON.parse(this.props.mapping.responsible_roles)  })

    this.setState({positive_application_status:this.props.mapping.positive_application_status})
    this.setState({negative_application_status:this.props.mapping.negative_application_status})
    this.setState({granting_stage:this.props.mapping.granting_stage})
    this.setState({application_status_forgranting_licence:this.props.mapping.application_status_forgranting_licence})

    this.setState({datarequested:true})

    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("username")){
      username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
   
   }else{
      username=''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


    axios.get(serverconfig.backendserverurl+`/api/actions/`)
    .then(res => {
        this.setState({
          actions:res.data
        })
      })

    axios.get(serverconfig.backendserverurl+`/api/staff_roles/`)
    .then(res => {
        this.setState({
          staff_roles:res.data
        })
  
        this.setState({datarequested:false})
    })



  }


  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})
    let form_data = new FormData();
    form_data.append('responsible_roles',JSON.stringify(this.state.responsible_roles) );
    form_data.append('mapping_id', this.props.mapping.id);

    form_data.append('positive_application_status',this.state.positive_application_status );
    form_data.append('negative_application_status',this.state.negative_application_status );

    form_data.append('granting_stage',this.state.granting_stage);
    form_data.append('application_status_forgranting_licence',this.state.application_status_forgranting_licence );

    axios.post(serverconfig.backendserverurl+`/customqueries/update_actionworkflowmapping`, form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  .then(res => {
    this.setState({responsible_roles:[]})
    this.setState({action:''})

    this.setState({datarequested:false})
    this.component_reloaded()

    ///refesrh
    this.props.onRefresh()

  }    

  )
  .catch(error => console.log(error))

  }

  
  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return (
        <div>
    <Form
        onFinish={(event) => this.handleFormSubmit(event)}
    >
      <h3>Update Form</h3>

       {
            this.state.staff_roles.length>0?
            <div style={{display:'flex',flexDirection:'column'}}>
            <h6>Responsible Roles for the action.</h6>

            {this.state.staff_roles.map((item) => (
              <p style={{display:'flex',flexDirection:'row'}}>
              <Switch
                onChange={(val) => {
                  if (val === true) {
                   
                    var new_array = [
                      ...this.state.responsible_roles,
                      item.name,
                    ];
                    this.setState({ responsible_roles: new_array });
                  } else {
                    this.setState({
                      responsible_roles: [
                        ...this.state.responsible_roles.filter(
                          (todo) => todo!== item.name
                        ),
                      ],
                    });
                  }
                }}
                style={{marginRight:2}} 

              ></Switch>{" "}
              {item.name} 
            </p>
            ))}
            <Divider></Divider>
            </div>
            :
            null
          }

      <FormItem label="Application Status(Positive Outcome)">
        <Input 
          name="positive_application_status"
          placeholder="positive_application_status."
          value={this.state.positive_application_status} 
          onChange={(val)=>{this.setState({positive_application_status:val.target.value})}} />
      </FormItem>


      <FormItem label="Application Status(Negative Outcome)">
        <Input name="negative_application_status" 
         placeholder="negative_application_status." 
         value={this.state.negative_application_status}
          onChange={(val)=>{this.setState({negative_application_status:val.target.value})}} />
      </FormItem>


      <Form.Item label="Licence Granting Stage?" >
        <Switch
            checked={this.state.granting_stage}
            onChange={val=>{this.setState({granting_stage:val})}}
            checkedChildren="Yes"
            unCheckedChildren="No"
            />
      </Form.Item>


      <FormItem label="Application status to activate Granting Action">
        <Input name="application_status_forgranting_licence" 
         placeholder="application_status_forgranting_licence." 
         value={this.state.application_status_forgranting_licence}
          onChange={(val)=>{this.setState({application_status_forgranting_licence:val.target.value})}} />
      </FormItem>


      <FormItem>
        <Button  type="primary" htmlType="submit">Update Action</Button>
      </FormItem>
       </Form>
        </div>
      );
    }

  }

}


export default ActionWorkFlowMappingUpdateForm;



